import axios from 'axios';

export class EmailAdminService {
    getEmailAdmin(email) {
        return axios.get('/appapv/getEmailAdmin.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                correo: email,
            }
        }).then(res => res.data.payload);
    }

    addNewEmailAdmin(email) {
        return axios.post('/appapv/addNewEmailAdmin.action', {}, {
            params: {
                correo: email,
            }
        }).then(res => this.getEmailAdmin(""));
    }

    deleteEmailAdmin(email) {
        return axios.delete('/appapv/deleteEmailAdmin.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                correo: email,
            }
        }).then(res => this.getEmailAdmin(""));
    }
}